module.exports = __webpack_public_path__ + "img/spin.c862cb62.svg";